// Generated by Framer (d74aa50)
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { addFonts, addPropertyControls, ComponentViewportProvider, ControlType, cx, getFonts, getFontsFromSharedStyle, getLoadingLazyAtYPosition, Image, Link, RichText, SmartComponentScopedContainer, useActiveVariantCallback, useComponentViewport, useLocaleInfo, useVariantState, withCSS, withFX, withOptimizedAppearEffect } from "framer";
import { LayoutGroup, motion, MotionConfigContext } from "framer-motion";
import * as React from "react";
import { useRef } from "react";
import * as sharedStyle from "https://framerusercontent.com/modules/jrJYG3qFKtNAE9jV5N1Y/r8X9obsXSeTNDoKaTX8x/cBrvg8Oyy.js";
import * as sharedStyle2 from "https://framerusercontent.com/modules/3J57oeBJoeysZ4E3GIZp/eiDjtd60uU2CAFpABIF5/doUCpi5z9.js";
import * as sharedStyle1 from "https://framerusercontent.com/modules/dnkWFlGc9jRuGEp6GfId/SwCoBbRhcc1euNwDUWZt/GTISKlX0X.js";
import NavigationHamburger from "https://framerusercontent.com/modules/o542RO74VzqHBXMehMDN/2XQYuBGIOkUDAREkZd5F/BMejH6OL8.js";
import NavButton from "https://framerusercontent.com/modules/yfVigg06p3VMMZUVaIaF/AfJzC1FYoIwVvCaiaEXk/yG10ruTg3.js";
const MotionDivWithFX = withFX(motion.div);
const NavigationHamburgerFonts = getFonts(NavigationHamburger);
const NavButtonFonts = getFonts(NavButton);
const MotionDivWithFXWithOptimizedAppearEffect = withOptimizedAppearEffect(withFX(motion.div));
const cycleOrder = ["vvHTF7cU2", "fmKE710k7", "AoNDX6eEV"];
const serializationHash = "framer-odTf6";
const variantClassNames = {
  AoNDX6eEV: "framer-v-urb5r4",
  fmKE710k7: "framer-v-18qkuva",
  vvHTF7cU2: "framer-v-1q8jo7l"
};
function addPropertyOverrides(overrides, ...variants) {
  const nextOverrides = {};
  variants?.forEach(variant => variant && Object.assign(nextOverrides, overrides[variant]));
  return nextOverrides;
}
const transition1 = {
  bounce: 0.2,
  delay: 0,
  duration: 0.4,
  type: "spring"
};
const transition2 = {
  delay: 0,
  duration: 0.9,
  ease: [0.12, 0.23, 0.4, 0.97],
  type: "tween"
};
const transition3 = {
  delay: 0,
  duration: 0.8,
  ease: [0.12, 0.23, 0.4, 0.97],
  type: "tween"
};
const animation = {
  opacity: 0,
  rotate: 0,
  rotateX: 0,
  rotateY: 0,
  scale: 1,
  skewX: 0,
  skewY: 0,
  x: 0,
  y: 0
};
const animation1 = {
  opacity: 1,
  rotate: 0,
  rotateX: 0,
  rotateY: 0,
  scale: 1,
  skewX: 0,
  skewY: 0,
  transition: transition1,
  x: 0,
  y: 0
};
const transition4 = {
  delay: 0,
  duration: 1,
  ease: [0.12, 0.23, 0.17, 0.99],
  type: "tween"
};
const animation2 = {
  opacity: 1,
  rotate: 0,
  rotateX: 0,
  rotateY: 0,
  scale: 1,
  skewX: 0,
  skewY: 0,
  transition: transition4,
  x: 0,
  y: 0
};
const animation3 = {
  opacity: 0.001,
  rotate: 0,
  rotateX: 0,
  rotateY: 0,
  scale: 1,
  skewX: 0,
  skewY: 0,
  x: 0,
  y: -40
};
const Transition = ({
  value,
  children
}) => {
  const config = React.useContext(MotionConfigContext);
  const transition = value ?? config.transition;
  const contextValue = React.useMemo(() => ({
    ...config,
    transition
  }), [JSON.stringify(transition)]);
  return /*#__PURE__*/_jsx(MotionConfigContext.Provider, {
    value: contextValue,
    children: children
  });
};
const Variants = motion.create(React.Fragment);
const humanReadableVariantMap = {
  "Mobile Closed": "fmKE710k7",
  "Mobile Opened": "AoNDX6eEV",
  Desktop: "vvHTF7cU2"
};
const getProps = ({
  bGAppearing,
  height,
  id,
  width,
  ...props
}) => {
  return {
    ...props,
    IFQnKk1ZS: bGAppearing ?? props.IFQnKk1ZS,
    variant: humanReadableVariantMap[props.variant] ?? props.variant ?? "vvHTF7cU2"
  };
};
const createLayoutDependency = (props, variants) => {
  if (props.layoutDependency) return variants.join("-") + props.layoutDependency;
  return variants.join("-");
};
const Component = /*#__PURE__*/React.forwardRef(function (props, ref) {
  const fallbackRef = useRef(null);
  const refBinding = ref ?? fallbackRef;
  const defaultLayoutId = React.useId();
  const {
    activeLocale,
    setLocale
  } = useLocaleInfo();
  const componentViewport = useComponentViewport();
  const {
    style,
    className,
    layoutId,
    variant,
    IFQnKk1ZS,
    ...restProps
  } = getProps(props);
  const {
    baseVariant,
    classNames,
    clearLoadingGesture,
    gestureHandlers,
    gestureVariant,
    isLoading,
    setGestureState,
    setVariant,
    variants
  } = useVariantState({
    cycleOrder,
    defaultVariant: "vvHTF7cU2",
    ref: refBinding,
    variant,
    variantClassNames
  });
  const layoutDependency = createLayoutDependency(props, variants);
  const {
    activeVariantCallback,
    delay
  } = useActiveVariantCallback(baseVariant);
  const mNnEtKoz718ysh47 = activeVariantCallback(async (...args) => {
    setVariant("rTivEYaFN");
  });
  const mNnEtKoz710zsyny = activeVariantCallback(async (...args) => {
    setVariant("AoNDX6eEV");
  });
  const mNnEtKoz71em3cku = activeVariantCallback(async (...args) => {
    setVariant("fmKE710k7");
  });
  const onTap1em3cku = activeVariantCallback(async (...args) => {
    setVariant("fmKE710k7");
  });
  const sharedStyleClassNames = [sharedStyle.className, sharedStyle1.className, sharedStyle2.className];
  const scopingClassNames = cx(serializationHash, ...sharedStyleClassNames);
  const isDisplayed = () => {
    if (["fmKE710k7", "AoNDX6eEV"].includes(baseVariant)) return false;
    return true;
  };
  const isDisplayed1 = () => {
    if (["fmKE710k7", "AoNDX6eEV"].includes(baseVariant)) return true;
    return false;
  };
  const isDisplayed2 = () => {
    if (baseVariant === "AoNDX6eEV") return true;
    return false;
  };
  return /*#__PURE__*/_jsx(LayoutGroup, {
    id: layoutId ?? defaultLayoutId,
    children: /*#__PURE__*/_jsx(Variants, {
      animate: variants,
      initial: false,
      children: /*#__PURE__*/_jsx(Transition, {
        value: transition1,
        ...addPropertyOverrides({
          AoNDX6eEV: {
            value: transition3
          },
          fmKE710k7: {
            value: transition2
          }
        }, baseVariant, gestureVariant),
        children: /*#__PURE__*/_jsxs(motion.nav, {
          ...restProps,
          ...gestureHandlers,
          className: cx(scopingClassNames, "framer-1q8jo7l", className, classNames),
          "data-framer-name": "Desktop",
          layoutDependency: layoutDependency,
          layoutId: "vvHTF7cU2",
          ref: refBinding,
          style: {
            ...style
          },
          ...addPropertyOverrides({
            AoNDX6eEV: {
              "data-framer-name": "Mobile Opened"
            },
            fmKE710k7: {
              "data-framer-name": "Mobile Closed"
            }
          }, baseVariant, gestureVariant),
          children: [/*#__PURE__*/_jsx(MotionDivWithFX, {
            __framer__animate: {
              transition: transition1
            },
            __framer__animateOnce: false,
            __framer__enter: animation,
            __framer__exit: animation1,
            __framer__styleAppearEffectEnabled: true,
            __framer__targets: [{
              ref: IFQnKk1ZS,
              target: "animate"
            }],
            __framer__threshold: 0,
            __perspectiveFX: false,
            __smartComponentFX: true,
            __targetOpacity: 1,
            className: "framer-wo6erx",
            "data-border": true,
            "data-framer-name": "BG",
            layoutDependency: layoutDependency,
            layoutId: "uudLmisw_",
            style: {
              "--border-bottom-width": "1px",
              "--border-color": "var(--token-0aa53fec-fefb-40a3-a229-e26994a82701, rgb(32, 32, 38))",
              "--border-left-width": "0px",
              "--border-right-width": "0px",
              "--border-style": "solid",
              "--border-top-width": "0px",
              backdropFilter: "blur(10px)",
              backgroundColor: "rgba(8, 7, 14, 0.8)",
              WebkitBackdropFilter: "blur(10px)"
            },
            ...addPropertyOverrides({
              AoNDX6eEV: {
                __framer__styleAppearEffectEnabled: undefined
              }
            }, baseVariant, gestureVariant)
          }), /*#__PURE__*/_jsxs(motion.div, {
            className: "framer-z994gj",
            layoutDependency: layoutDependency,
            layoutId: "AMWrwi3h_",
            children: [/*#__PURE__*/_jsxs(motion.div, {
              className: "framer-1awdup3",
              "data-framer-name": "Links",
              layoutDependency: layoutDependency,
              layoutId: "wXZwVhP6l",
              children: [/*#__PURE__*/_jsxs(motion.div, {
                className: "framer-1a3auhl",
                "data-framer-name": "Logo",
                layoutDependency: layoutDependency,
                layoutId: "YAA06crus",
                children: [/*#__PURE__*/_jsx(Image, {
                  background: {
                    alt: "",
                    fit: "fill",
                    intrinsicHeight: 960,
                    intrinsicWidth: 960,
                    loading: getLoadingLazyAtYPosition((componentViewport?.y || 0) + 24 + 0 + 8 + 0 + 0),
                    pixelHeight: 1200,
                    pixelWidth: 1200,
                    sizes: "32px",
                    src: globalThis.__COLLABYN_IMAGES__?.["https://framerusercontent.com/images/BBiARPR2zxueAJLEJUALklWW8.png"] ?? "/assets/4d6929cba32b-BBiARPR2zxueAJLEJUALklWW8.png",
                    srcSet: globalThis.__COLLABYN_IMAGES__?.["https://framerusercontent.com/images/BBiARPR2zxueAJLEJUALklWW8.png"] ?? "/assets/98849280ea86-BBiARPR2zxueAJLEJUALklWW8.png 512w,/assets/4d6929cba32b-BBiARPR2zxueAJLEJUALklWW8.png 1024w,/assets/156d8da84da9-BBiARPR2zxueAJLEJUALklWW8.png 1200w"
                  },
                  className: "framer-36la3s",
                  "data-framer-name": "Collabyn logo final",
                  layoutDependency: layoutDependency,
                  layoutId: "MyXKRrRaq",
                  ...addPropertyOverrides({
                    AoNDX6eEV: {
                      background: {
                        alt: "",
                        fit: "fill",
                        intrinsicHeight: 960,
                        intrinsicWidth: 960,
                        loading: getLoadingLazyAtYPosition((componentViewport?.y || 0) + 16 + 0 + 0 + 0 + 0 + 0),
                        pixelHeight: 1200,
                        pixelWidth: 1200,
                        sizes: "32px",
                        src: globalThis.__COLLABYN_IMAGES__?.["https://framerusercontent.com/images/BBiARPR2zxueAJLEJUALklWW8.png"] ?? "/assets/4d6929cba32b-BBiARPR2zxueAJLEJUALklWW8.png",
                        srcSet: globalThis.__COLLABYN_IMAGES__?.["https://framerusercontent.com/images/BBiARPR2zxueAJLEJUALklWW8.png"] ?? "/assets/98849280ea86-BBiARPR2zxueAJLEJUALklWW8.png 512w,/assets/4d6929cba32b-BBiARPR2zxueAJLEJUALklWW8.png 1024w,/assets/156d8da84da9-BBiARPR2zxueAJLEJUALklWW8.png 1200w"
                      }
                    },
                    fmKE710k7: {
                      background: {
                        alt: "",
                        fit: "fill",
                        intrinsicHeight: 960,
                        intrinsicWidth: 960,
                        loading: getLoadingLazyAtYPosition((componentViewport?.y || 0) + 16 + 0 + 0 + 0 + 0 + 0),
                        pixelHeight: 1200,
                        pixelWidth: 1200,
                        sizes: "32px",
                        src: globalThis.__COLLABYN_IMAGES__?.["https://framerusercontent.com/images/BBiARPR2zxueAJLEJUALklWW8.png"] ?? "/assets/4d6929cba32b-BBiARPR2zxueAJLEJUALklWW8.png",
                        srcSet: globalThis.__COLLABYN_IMAGES__?.["https://framerusercontent.com/images/BBiARPR2zxueAJLEJUALklWW8.png"] ?? "/assets/98849280ea86-BBiARPR2zxueAJLEJUALklWW8.png 512w,/assets/4d6929cba32b-BBiARPR2zxueAJLEJUALklWW8.png 1024w,/assets/156d8da84da9-BBiARPR2zxueAJLEJUALklWW8.png 1200w"
                      }
                    }
                  }, baseVariant, gestureVariant)
                }), /*#__PURE__*/_jsx(RichText, {
                  __fromCanvasComponent: true,
                  children: /*#__PURE__*/_jsx(React.Fragment, {
                    children: /*#__PURE__*/_jsx(motion.p, {
                      style: {
                        "--font-selector": "R0Y7UGxheWZhaXIgRGlzcGxheS01MDA=",
                        "--framer-font-family": '"Playfair Display", "Playfair Display Placeholder", serif',
                        "--framer-font-size": "24px",
                        "--framer-font-weight": "500",
                        "--framer-letter-spacing": "0px",
                        "--framer-line-height": "32px",
                        "--framer-text-color": "var(--extracted-r6o4lv, var(--token-9c9cb5e4-a45a-458a-9159-f07c4a87b234, rgb(245, 245, 245)))"
                      },
                      children: globalThis.__COLLABYN_COPY__?.["Collabyn"] ?? "Collabyn"
                    })
                  }),
                  className: "framer-sk2xew",
                  "data-framer-name": "Cryptix",
                  fonts: ["GF;Playfair Display-500"],
                  layoutDependency: layoutDependency,
                  layoutId: "ooIrsxqFb",
                  style: {
                    "--extracted-r6o4lv": "var(--token-9c9cb5e4-a45a-458a-9159-f07c4a87b234, rgb(245, 245, 245))",
                    "--framer-paragraph-spacing": "0px"
                  },
                  verticalAlignment: "top",
                  withExternalLayout: true,
                  ...addPropertyOverrides({
                    AoNDX6eEV: {
                      children: /*#__PURE__*/_jsx(React.Fragment, {
                        children: /*#__PURE__*/_jsx(motion.p, {
                          style: {
                            "--font-selector": "R0Y7UGxheWZhaXIgRGlzcGxheS01MDA=",
                            "--framer-font-family": '"Playfair Display", "Playfair Display Placeholder", serif',
                            "--framer-font-size": "20px",
                            "--framer-font-weight": "500",
                            "--framer-letter-spacing": "0px",
                            "--framer-line-height": "28px",
                            "--framer-text-color": "var(--extracted-r6o4lv, var(--token-9c9cb5e4-a45a-458a-9159-f07c4a87b234, rgb(245, 245, 245)))"
                          },
                          children: globalThis.__COLLABYN_COPY__?.["Collabyn"] ?? "Collabyn"
                        })
                      })
                    },
                    fmKE710k7: {
                      children: /*#__PURE__*/_jsx(React.Fragment, {
                        children: /*#__PURE__*/_jsx(motion.p, {
                          style: {
                            "--font-selector": "R0Y7UGxheWZhaXIgRGlzcGxheS01MDA=",
                            "--framer-font-family": '"Playfair Display", "Playfair Display Placeholder", serif',
                            "--framer-font-size": "20px",
                            "--framer-font-weight": "500",
                            "--framer-letter-spacing": "0px",
                            "--framer-line-height": "28px",
                            "--framer-text-color": "var(--extracted-r6o4lv, var(--token-9c9cb5e4-a45a-458a-9159-f07c4a87b234, rgb(245, 245, 245)))"
                          },
                          children: globalThis.__COLLABYN_COPY__?.["Collabyn"] ?? "Collabyn"
                        })
                      })
                    }
                  }, baseVariant, gestureVariant)
                })]
              }), isDisplayed() && /*#__PURE__*/_jsxs(motion.div, {
                className: "framer-1umt4ki",
                "data-framer-name": "Navigation Menu",
                layoutDependency: layoutDependency,
                layoutId: "pPnikKfa2",
                children: [/*#__PURE__*/_jsx(RichText, {
                  __fromCanvasComponent: true,
                  children: /*#__PURE__*/_jsx(React.Fragment, {
                    children: /*#__PURE__*/_jsx(motion.p, {
                      className: "framer-styles-preset-21bipq",
                      "data-styles-preset": "cBrvg8Oyy",
                      children: /*#__PURE__*/_jsx(Link, {
                        href: {
                          hash: ":wJCoP1HKt",
                          webPageId: "augiA20Il"
                        },
                        motionChild: true,
                        nodeId: "K2KbJBTui",
                        openInNewTab: false,
                        preserveParams: false,
                        relValues: [],
                        scopeId: "MXqfFzPbq",
                        smoothScroll: true,
                        children: /*#__PURE__*/_jsx(motion.a, {
                          className: "framer-styles-preset-1dlfqf2",
                          "data-styles-preset": "GTISKlX0X",
                          children: globalThis.__COLLABYN_COPY__?.["Home"] ?? "Home"
                        })
                      })
                    })
                  }),
                  className: "framer-1m2oetn",
                  "data-framer-name": "Why",
                  fonts: ["Inter"],
                  layoutDependency: layoutDependency,
                  layoutId: "K2KbJBTui",
                  style: {
                    "--framer-paragraph-spacing": "0px"
                  },
                  verticalAlignment: "top",
                  withExternalLayout: true
                }), /*#__PURE__*/_jsx(RichText, {
                  __fromCanvasComponent: true,
                  children: /*#__PURE__*/_jsx(React.Fragment, {
                    children: /*#__PURE__*/_jsx(motion.p, {
                      className: "framer-styles-preset-21bipq",
                      "data-styles-preset": "cBrvg8Oyy",
                      children: /*#__PURE__*/_jsx(Link, {
                        href: {
                          hash: ":bS1G9Sni_",
                          webPageId: "augiA20Il"
                        },
                        motionChild: true,
                        nodeId: "L_DTuz5_p",
                        openInNewTab: false,
                        preserveParams: false,
                        relValues: [],
                        scopeId: "MXqfFzPbq",
                        smoothScroll: true,
                        children: /*#__PURE__*/_jsx(motion.a, {
                          className: "framer-styles-preset-1dlfqf2",
                          "data-styles-preset": "GTISKlX0X",
                          children: globalThis.__COLLABYN_COPY__?.["Features"] ?? "Features"
                        })
                      })
                    })
                  }),
                  className: "framer-117tde8",
                  "data-framer-name": "HowItWorks",
                  fonts: ["Inter"],
                  layoutDependency: layoutDependency,
                  layoutId: "L_DTuz5_p",
                  style: {
                    "--framer-paragraph-spacing": "0px"
                  },
                  verticalAlignment: "top",
                  withExternalLayout: true
                }), /*#__PURE__*/_jsx(RichText, {
                  __fromCanvasComponent: true,
                  children: /*#__PURE__*/_jsx(React.Fragment, {
                    children: /*#__PURE__*/_jsx(motion.p, {
                      className: "framer-styles-preset-21bipq",
                      "data-styles-preset": "cBrvg8Oyy",
                      children: /*#__PURE__*/_jsx(Link, {
                        href: {
                          hash: ":YBiNeOYcb",
                          webPageId: "augiA20Il"
                        },
                        motionChild: true,
                        nodeId: "ctCzlKdlH",
                        openInNewTab: false,
                        preserveParams: false,
                        relValues: [],
                        scopeId: "MXqfFzPbq",
                        smoothScroll: false,
                        children: /*#__PURE__*/_jsx(motion.a, {
                          className: "framer-styles-preset-1dlfqf2",
                          "data-styles-preset": "GTISKlX0X",
                          children: globalThis.__COLLABYN_COPY__?.["Values"] ?? "Values"
                        })
                      })
                    })
                  }),
                  className: "framer-haotgq",
                  "data-framer-name": "Cryptos",
                  fonts: ["Inter"],
                  layoutDependency: layoutDependency,
                  layoutId: "ctCzlKdlH",
                  style: {
                    "--framer-paragraph-spacing": "0px"
                  },
                  verticalAlignment: "top",
                  withExternalLayout: true
                }), /*#__PURE__*/_jsx(RichText, {
                  __fromCanvasComponent: true,
                  children: /*#__PURE__*/_jsx(React.Fragment, {
                    children: /*#__PURE__*/_jsx(motion.p, {
                      className: "framer-styles-preset-21bipq",
                      "data-styles-preset": "cBrvg8Oyy",
                      children: /*#__PURE__*/_jsx(Link, {
                        href: {
                          hash: ":ICQeMyiyD",
                          webPageId: "augiA20Il"
                        },
                        motionChild: true,
                        nodeId: "zeQKkTZ6C",
                        openInNewTab: false,
                        preserveParams: false,
                        relValues: [],
                        scopeId: "MXqfFzPbq",
                        smoothScroll: false,
                        children: /*#__PURE__*/_jsx(motion.a, {
                          className: "framer-styles-preset-1dlfqf2",
                          "data-styles-preset": "GTISKlX0X",
                          children: globalThis.__COLLABYN_COPY__?.["Pricing"] ?? "Pricing"
                        })
                      })
                    })
                  }),
                  className: "framer-17fntxw",
                  "data-framer-name": "HowItWorks",
                  fonts: ["Inter"],
                  layoutDependency: layoutDependency,
                  layoutId: "zeQKkTZ6C",
                  style: {
                    "--framer-paragraph-spacing": "0px"
                  },
                  verticalAlignment: "top",
                  withExternalLayout: true
                }), /*#__PURE__*/_jsx(RichText, {
                  __fromCanvasComponent: true,
                  children: /*#__PURE__*/_jsx(React.Fragment, {
                    children: /*#__PURE__*/_jsx(motion.p, {
                      className: "framer-styles-preset-21bipq",
                      "data-styles-preset": "cBrvg8Oyy",
                      children: /*#__PURE__*/_jsx(Link, {
                        href: {
                          hash: ":w0Wr2L5KY",
                          webPageId: "augiA20Il"
                        },
                        motionChild: true,
                        nodeId: "xg1NFB7bh",
                        openInNewTab: false,
                        preserveParams: false,
                        relValues: [],
                        scopeId: "MXqfFzPbq",
                        smoothScroll: true,
                        children: /*#__PURE__*/_jsx(motion.a, {
                          className: "framer-styles-preset-1dlfqf2",
                          "data-styles-preset": "GTISKlX0X",
                          children: globalThis.__COLLABYN_COPY__?.["FAQ"] ?? "FAQ"
                        })
                      })
                    })
                  }),
                  className: "framer-12kmo91",
                  "data-framer-name": "FAQ",
                  fonts: ["Inter"],
                  layoutDependency: layoutDependency,
                  layoutId: "xg1NFB7bh",
                  style: {
                    "--framer-paragraph-spacing": "0px"
                  },
                  verticalAlignment: "top",
                  withExternalLayout: true
                })]
              })]
            }), /*#__PURE__*/_jsxs(motion.div, {
              className: "framer-1eaor39",
              "data-framer-name": "CTAs",
              layoutDependency: layoutDependency,
              layoutId: "tcl9WPUrw",
              children: [isDisplayed1() && /*#__PURE__*/_jsx(ComponentViewportProvider, {
                ...addPropertyOverrides({
                  AoNDX6eEV: {
                    height: 31,
                    width: "31px",
                    y: (componentViewport?.y || 0) + 16 + 0 + 0.5 + 0
                  },
                  fmKE710k7: {
                    height: 31,
                    width: "31px",
                    y: (componentViewport?.y || 0) + 16 + 0 + 0.5 + 0
                  }
                }, baseVariant, gestureVariant),
                children: /*#__PURE__*/_jsx(SmartComponentScopedContainer, {
                  className: "framer-tb5f2o-container",
                  layoutDependency: layoutDependency,
                  layoutId: "ogJnP8wuy-container",
                  nodeId: "ogJnP8wuy",
                  rendersWithMotion: true,
                  scopeId: "MXqfFzPbq",
                  children: /*#__PURE__*/_jsx(NavigationHamburger, {
                    height: "100%",
                    id: "ogJnP8wuy",
                    layoutId: "ogJnP8wuy",
                    mNnEtKoz7: mNnEtKoz718ysh47,
                    style: {
                      height: "100%",
                      width: "100%"
                    },
                    variant: "Q6IWiB4Vd",
                    width: "100%",
                    ...addPropertyOverrides({
                      AoNDX6eEV: {
                        mNnEtKoz7: mNnEtKoz71em3cku,
                        variant: "AKDNPwvdD"
                      },
                      fmKE710k7: {
                        mNnEtKoz7: mNnEtKoz710zsyny
                      }
                    }, baseVariant, gestureVariant)
                  })
                })
              }), isDisplayed() && /*#__PURE__*/_jsx(ComponentViewportProvider, {
                height: 48,
                y: (componentViewport?.y || 0) + 24 + 0 + 0 + 0,
                children: /*#__PURE__*/_jsx(SmartComponentScopedContainer, {
                  className: "framer-12a5r3x-container",
                  layoutDependency: layoutDependency,
                  layoutId: "rurdh3gcX-container",
                  nodeId: "rurdh3gcX",
                  rendersWithMotion: true,
                  scopeId: "MXqfFzPbq",
                  children: /*#__PURE__*/_jsx(NavButton, {
                    height: "100%",
                    id: "rurdh3gcX",
                    layoutId: "rurdh3gcX",
                    style: {
                      height: "100%"
                    },
                    variant: "oF0UX6Piw",
                    width: "100%"
                  })
                })
              })]
            })]
          }), isDisplayed2() && /*#__PURE__*/_jsxs(MotionDivWithFXWithOptimizedAppearEffect, {
            __perspectiveFX: false,
            __smartComponentFX: true,
            __targetOpacity: 1,
            animate: animation2,
            className: "framer-19xhd3q",
            "data-framer-appear-id": "19xhd3q",
            "data-framer-name": "Navigation Menu (Mobile)",
            initial: animation3,
            layoutDependency: layoutDependency,
            layoutId: "xF97LttjL",
            optimized: true,
            children: [/*#__PURE__*/_jsx(RichText, {
              __fromCanvasComponent: true,
              children: /*#__PURE__*/_jsx(React.Fragment, {
                children: /*#__PURE__*/_jsx(motion.p, {
                  className: "framer-styles-preset-1dkivo1",
                  "data-styles-preset": "doUCpi5z9",
                  children: /*#__PURE__*/_jsx(Link, {
                    href: {
                      hash: ":wJCoP1HKt",
                      webPageId: "augiA20Il"
                    },
                    motionChild: true,
                    nodeId: "ewoj5BuQx",
                    openInNewTab: false,
                    preserveParams: false,
                    relValues: [],
                    scopeId: "MXqfFzPbq",
                    smoothScroll: true,
                    children: /*#__PURE__*/_jsx(motion.a, {
                      className: "framer-styles-preset-1dlfqf2",
                      "data-styles-preset": "GTISKlX0X",
                      children: globalThis.__COLLABYN_COPY__?.["Home"] ?? "Home"
                    })
                  })
                })
              }),
              className: "framer-a9lahy",
              "data-framer-name": "Why",
              "data-highlight": true,
              fonts: ["Inter"],
              layoutDependency: layoutDependency,
              layoutId: "ewoj5BuQx",
              onTap: onTap1em3cku,
              style: {
                "--framer-paragraph-spacing": "0px"
              },
              verticalAlignment: "top",
              withExternalLayout: true
            }), /*#__PURE__*/_jsx(RichText, {
              __fromCanvasComponent: true,
              children: /*#__PURE__*/_jsx(React.Fragment, {
                children: /*#__PURE__*/_jsx(motion.p, {
                  className: "framer-styles-preset-1dkivo1",
                  "data-styles-preset": "doUCpi5z9",
                  children: /*#__PURE__*/_jsx(Link, {
                    href: {
                      hash: ":YBiNeOYcb",
                      webPageId: "augiA20Il"
                    },
                    motionChild: true,
                    nodeId: "iXFmXurvP",
                    openInNewTab: false,
                    preserveParams: false,
                    relValues: [],
                    scopeId: "MXqfFzPbq",
                    smoothScroll: true,
                    children: /*#__PURE__*/_jsx(motion.a, {
                      className: "framer-styles-preset-1dlfqf2",
                      "data-styles-preset": "GTISKlX0X",
                      children: globalThis.__COLLABYN_COPY__?.["Values"] ?? "Values"
                    })
                  })
                })
              }),
              className: "framer-1rx722f",
              "data-framer-name": "Cryptos",
              "data-highlight": true,
              fonts: ["Inter"],
              layoutDependency: layoutDependency,
              layoutId: "iXFmXurvP",
              onTap: onTap1em3cku,
              style: {
                "--framer-paragraph-spacing": "0px"
              },
              verticalAlignment: "top",
              withExternalLayout: true
            }), /*#__PURE__*/_jsx(RichText, {
              __fromCanvasComponent: true,
              children: /*#__PURE__*/_jsx(React.Fragment, {
                children: /*#__PURE__*/_jsx(motion.p, {
                  className: "framer-styles-preset-1dkivo1",
                  "data-styles-preset": "doUCpi5z9",
                  children: /*#__PURE__*/_jsx(Link, {
                    href: {
                      hash: ":bS1G9Sni_",
                      webPageId: "augiA20Il"
                    },
                    motionChild: true,
                    nodeId: "au1KuxwOq",
                    openInNewTab: false,
                    preserveParams: false,
                    relValues: [],
                    scopeId: "MXqfFzPbq",
                    smoothScroll: true,
                    children: /*#__PURE__*/_jsx(motion.a, {
                      className: "framer-styles-preset-1dlfqf2",
                      "data-styles-preset": "GTISKlX0X",
                      children: globalThis.__COLLABYN_COPY__?.["Features"] ?? "Features"
                    })
                  })
                })
              }),
              className: "framer-16nfuvn",
              "data-framer-name": "HowItWorks",
              "data-highlight": true,
              fonts: ["Inter"],
              layoutDependency: layoutDependency,
              layoutId: "au1KuxwOq",
              onTap: onTap1em3cku,
              style: {
                "--framer-paragraph-spacing": "0px"
              },
              verticalAlignment: "top",
              withExternalLayout: true
            }), /*#__PURE__*/_jsx(RichText, {
              __fromCanvasComponent: true,
              children: /*#__PURE__*/_jsx(React.Fragment, {
                children: /*#__PURE__*/_jsx(motion.p, {
                  className: "framer-styles-preset-1dkivo1",
                  "data-styles-preset": "doUCpi5z9",
                  children: /*#__PURE__*/_jsx(Link, {
                    href: {
                      hash: ":ICQeMyiyD",
                      webPageId: "augiA20Il"
                    },
                    motionChild: true,
                    nodeId: "NCdfIjurP",
                    openInNewTab: false,
                    preserveParams: false,
                    relValues: [],
                    scopeId: "MXqfFzPbq",
                    smoothScroll: true,
                    children: /*#__PURE__*/_jsx(motion.a, {
                      className: "framer-styles-preset-1dlfqf2",
                      "data-styles-preset": "GTISKlX0X",
                      children: globalThis.__COLLABYN_COPY__?.["Pricing"] ?? "Pricing"
                    })
                  })
                })
              }),
              className: "framer-e3q2me",
              "data-framer-name": "HowItWorks",
              "data-highlight": true,
              fonts: ["Inter"],
              layoutDependency: layoutDependency,
              layoutId: "NCdfIjurP",
              onTap: onTap1em3cku,
              style: {
                "--framer-paragraph-spacing": "0px"
              },
              verticalAlignment: "top",
              withExternalLayout: true
            }), /*#__PURE__*/_jsx(RichText, {
              __fromCanvasComponent: true,
              children: /*#__PURE__*/_jsx(React.Fragment, {
                children: /*#__PURE__*/_jsx(motion.p, {
                  className: "framer-styles-preset-1dkivo1",
                  "data-styles-preset": "doUCpi5z9",
                  children: /*#__PURE__*/_jsx(Link, {
                    href: {
                      hash: ":w0Wr2L5KY",
                      webPageId: "augiA20Il"
                    },
                    motionChild: true,
                    nodeId: "lJL5oIKYx",
                    openInNewTab: false,
                    preserveParams: false,
                    relValues: [],
                    scopeId: "MXqfFzPbq",
                    smoothScroll: true,
                    children: /*#__PURE__*/_jsx(motion.a, {
                      className: "framer-styles-preset-1dlfqf2",
                      "data-styles-preset": "GTISKlX0X",
                      children: globalThis.__COLLABYN_COPY__?.["FAQ"] ?? "FAQ"
                    })
                  })
                })
              }),
              className: "framer-br2d1a",
              "data-framer-name": "FAQ",
              "data-highlight": true,
              fonts: ["Inter"],
              layoutDependency: layoutDependency,
              layoutId: "lJL5oIKYx",
              onTap: onTap1em3cku,
              style: {
                "--framer-paragraph-spacing": "0px"
              },
              verticalAlignment: "top",
              withExternalLayout: true
            }), /*#__PURE__*/_jsx(ComponentViewportProvider, {
              height: 48,
              ...addPropertyOverrides({
                AoNDX6eEV: {
                  y: (componentViewport?.y || 0) + 16 + 56 + 0 + 250
                }
              }, baseVariant, gestureVariant),
              children: /*#__PURE__*/_jsx(SmartComponentScopedContainer, {
                className: "framer-bbwhoy-container",
                layoutDependency: layoutDependency,
                layoutId: "GejoNt6lx-container",
                nodeId: "GejoNt6lx",
                rendersWithMotion: true,
                scopeId: "MXqfFzPbq",
                children: /*#__PURE__*/_jsx(NavButton, {
                  height: "100%",
                  id: "GejoNt6lx",
                  layoutId: "GejoNt6lx",
                  style: {
                    height: "100%"
                  },
                  variant: "oF0UX6Piw",
                  width: "100%"
                })
              })
            })]
          })]
        })
      })
    })
  });
});
const css = ["@supports (aspect-ratio: 1) { body { --framer-aspect-ratio-supported: auto; } }", ".framer-odTf6.framer-1sx78kp, .framer-odTf6 .framer-1sx78kp { display: block; }", ".framer-odTf6.framer-1q8jo7l { align-content: center; align-items: center; display: flex; flex-direction: column; flex-wrap: nowrap; gap: 24px; height: min-content; justify-content: flex-start; overflow: visible; padding: 24px 0px 24px 0px; position: relative; width: 1184px; }", ".framer-odTf6 .framer-wo6erx { flex: none; height: 100%; left: 0px; overflow: hidden; position: absolute; top: 0px; width: 100%; z-index: 0; }", ".framer-odTf6 .framer-z994gj { align-content: center; align-items: center; display: flex; flex: none; flex-direction: row; flex-wrap: nowrap; height: min-content; justify-content: space-between; max-width: 1184px; overflow: visible; padding: 0px; position: relative; width: 100%; z-index: 1; }", ".framer-odTf6 .framer-1awdup3 { align-content: center; align-items: center; display: flex; flex: none; flex-direction: row; flex-wrap: nowrap; gap: 64px; height: min-content; justify-content: flex-start; overflow: visible; padding: 0px; position: relative; width: min-content; }", ".framer-odTf6 .framer-1a3auhl, .framer-odTf6 .framer-1eaor39 { align-content: center; align-items: center; display: flex; flex: none; flex-direction: row; flex-wrap: nowrap; gap: 8px; height: min-content; justify-content: flex-start; overflow: visible; padding: 0px; position: relative; width: min-content; }", ".framer-odTf6 .framer-36la3s { aspect-ratio: 1 / 1; flex: none; height: var(--framer-aspect-ratio-supported, 32px); overflow: visible; position: relative; width: 32px; }", ".framer-odTf6 .framer-sk2xew, .framer-odTf6 .framer-1m2oetn, .framer-odTf6 .framer-117tde8, .framer-odTf6 .framer-haotgq, .framer-odTf6 .framer-17fntxw, .framer-odTf6 .framer-12kmo91 { flex: none; height: auto; position: relative; white-space: pre; width: auto; }", ".framer-odTf6 .framer-1umt4ki { align-content: center; align-items: center; display: flex; flex: none; flex-direction: row; flex-wrap: nowrap; gap: 24px; height: min-content; justify-content: center; overflow: visible; padding: 0px; position: relative; width: min-content; }", ".framer-odTf6 .framer-tb5f2o-container { flex: none; height: 31px; position: relative; width: 31px; }", ".framer-odTf6 .framer-12a5r3x-container, .framer-odTf6 .framer-bbwhoy-container { flex: none; height: 48px; position: relative; width: auto; }", ".framer-odTf6 .framer-19xhd3q { align-content: center; align-items: center; display: flex; flex: none; flex-direction: column; flex-wrap: nowrap; gap: 24px; height: min-content; justify-content: center; max-width: 400px; overflow: visible; padding: 0px; position: relative; width: 100%; z-index: 1; }", ".framer-odTf6 .framer-a9lahy, .framer-odTf6 .framer-1rx722f, .framer-odTf6 .framer-16nfuvn, .framer-odTf6 .framer-e3q2me, .framer-odTf6 .framer-br2d1a { cursor: pointer; flex: none; height: auto; position: relative; white-space: pre; width: auto; }", ".framer-odTf6.framer-v-18qkuva.framer-1q8jo7l, .framer-odTf6.framer-v-urb5r4.framer-1q8jo7l { overflow: hidden; padding: 16px; width: 390px; }", ".framer-odTf6.framer-v-18qkuva .framer-1awdup3, .framer-odTf6.framer-v-urb5r4 .framer-1awdup3 { flex-direction: column; }", ".framer-odTf6.framer-v-urb5r4 .framer-a9lahy { order: 0; }", ".framer-odTf6.framer-v-urb5r4 .framer-1rx722f { order: 2; }", ".framer-odTf6.framer-v-urb5r4 .framer-16nfuvn { order: 1; }", ".framer-odTf6.framer-v-urb5r4 .framer-e3q2me { order: 3; }", ".framer-odTf6.framer-v-urb5r4 .framer-br2d1a { order: 4; }", ".framer-odTf6.framer-v-urb5r4 .framer-bbwhoy-container { order: 5; }", ...sharedStyle.css, ...sharedStyle1.css, ...sharedStyle2.css, '.framer-odTf6[data-border="true"]::after, .framer-odTf6 [data-border="true"]::after { content: ""; border-width: var(--border-top-width, 0) var(--border-right-width, 0) var(--border-bottom-width, 0) var(--border-left-width, 0); border-color: var(--border-color, none); border-style: var(--border-style, none); width: 100%; height: 100%; position: absolute; box-sizing: border-box; left: 0; top: 0; border-radius: inherit; pointer-events: none; }'];
/**
 * This is a generated Framer component.
 * @framerIntrinsicHeight 96
 * @framerIntrinsicWidth 1184
 * @framerCanvasComponentVariantDetails {"propertyName":"variant","data":{"default":{"layout":["fixed","auto"]},"fmKE710k7":{"layout":["fixed","auto"]},"AoNDX6eEV":{"layout":["fixed","auto"]}}}
 * @framerVariables {"IFQnKk1ZS":"bGAppearing"}
 * @framerImmutableVariables true
 * @framerDisplayContentsDiv false
 * @framerAutoSizeImages true
 * @framerComponentViewportWidth true
 * @framerColorSyntax true
 */
const FramerMXqfFzPbq = withCSS(Component, css, "framer-odTf6");
export default FramerMXqfFzPbq;
FramerMXqfFzPbq.displayName = "NavBar";
FramerMXqfFzPbq.defaultProps = {
  height: 96,
  width: 1184
};
addPropertyControls(FramerMXqfFzPbq, {
  variant: {
    options: ["vvHTF7cU2", "fmKE710k7", "AoNDX6eEV"],
    optionTitles: ["Desktop", "Mobile Closed", "Mobile Opened"],
    title: "Variant",
    type: ControlType.Enum
  },
  IFQnKk1ZS: {
    title: "BG-appearing",
    type: ControlType.ScrollSectionRef
  }
});
addFonts(FramerMXqfFzPbq, [{
  explicitInter: true,
  fonts: [{
    family: "Playfair Display",
    source: "google",
    style: "normal",
    url: "/assets/9534cf4de654-nuFvD-vYSZviVYUb_rj3ij__anPXJzDwcbmjWBN2PKd3vUDVZNLo_U2r.woff2",
    weight: "500"
  }, {
    family: "Inter",
    source: "framer",
    style: "normal",
    unicodeRange: "U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F",
    url: "/assets/ba02b29b109b-5vvr9Vy74if2I6bQbJvbw7SY1pQ.woff2",
    weight: "400"
  }, {
    family: "Inter",
    source: "framer",
    style: "normal",
    unicodeRange: "U+0301, U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116",
    url: "/assets/d342a0351181-EOr0mi4hNtlgWNn9if640EZzXCo.woff2",
    weight: "400"
  }, {
    family: "Inter",
    source: "framer",
    style: "normal",
    unicodeRange: "U+1F00-1FFF",
    url: "/assets/29ec2a1bd449-Y9k9QrlZAqio88Klkmbd8VoMQc.woff2",
    weight: "400"
  }, {
    family: "Inter",
    source: "framer",
    style: "normal",
    unicodeRange: "U+0370-03FF",
    url: "/assets/2666a469c59b-OYrD2tBIBPvoJXiIHnLoOXnY9M.woff2",
    weight: "400"
  }, {
    family: "Inter",
    source: "framer",
    style: "normal",
    unicodeRange: "U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF",
    url: "/assets/ca74d6701961-JeYwfuaPfZHQhEG8U5gtPDZ7WQ.woff2",
    weight: "400"
  }, {
    family: "Inter",
    source: "framer",
    style: "normal",
    unicodeRange: "U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD",
    url: "/assets/61418a355f78-vQyevYAyHtARFwPqUzQGpnDs.woff2",
    weight: "400"
  }, {
    family: "Inter",
    source: "framer",
    style: "normal",
    unicodeRange: "U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB",
    url: "/assets/b055aed328b3-b6Y37FthZeALduNqHicBT6FutY.woff2",
    weight: "400"
  }]
}, ...NavigationHamburgerFonts, ...NavButtonFonts, ...getFontsFromSharedStyle(sharedStyle.fonts), ...getFontsFromSharedStyle(sharedStyle1.fonts), ...getFontsFromSharedStyle(sharedStyle2.fonts)], {
  supportsExplicitInterCodegen: true
});
export const __FramerMetadata__ = {
  exports: {
    default: {
      type: "reactComponent",
      name: "FramerMXqfFzPbq",
      slots: [],
      annotations: {
        framerColorSyntax: "true",
        framerCanvasComponentVariantDetails: '{"propertyName":"variant","data":{"default":{"layout":["fixed","auto"]},"fmKE710k7":{"layout":["fixed","auto"]},"AoNDX6eEV":{"layout":["fixed","auto"]}}}',
        framerAutoSizeImages: "true",
        framerContractVersion: "1",
        framerIntrinsicHeight: "96",
        framerComponentViewportWidth: "true",
        framerImmutableVariables: "true",
        framerIntrinsicWidth: "1184",
        framerVariables: '{"IFQnKk1ZS":"bGAppearing"}',
        framerDisplayContentsDiv: "false"
      }
    },
    Props: {
      type: "tsType",
      annotations: {
        framerContractVersion: "1"
      }
    },
    __FramerMetadata__: {
      type: "variable"
    }
  }
};
//# sourceMappingURL=./MXqfFzPbq.map